import { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Text,
} from '@chakra-ui/react';

interface TargetHoursStepProps {
  value: number;
  onChange: (value: number) => void;
  onNext: () => void;
}

const TargetHoursStep = ({ value, onChange, onNext }: TargetHoursStepProps) => {
  const [error, setError] = useState<string | null>(null);
  
  const handleChange = (_: string, valueAsNumber: number) => {
    setError(null);
    onChange(valueAsNumber);
  };
  
  const handleNext = () => {
    if (value <= 0) {
      setError('Please enter a valid number of hours');
      return;
    }
    onNext();
  };
  
  return (
    <Box>
      <Text mb={6}>
        This is how many billable hours you need to achieve during your tracking period.
        Common targets for legal professionals range from 1,800 to 2,200 hours per year.
      </Text>
      
      <FormControl isInvalid={!!error} mb={8}>
        <FormLabel>Annual Billable Hours Target</FormLabel>
        <NumberInput 
          min={1} 
          max={5000} 
          step={10} 
          value={value}
          onChange={handleChange}
          size="lg"
        >
          <NumberInputField />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
        <FormHelperText>
          Enter your annual billable hours requirement
        </FormHelperText>
        {error && (
          <Text color="red.500" mt={2}>
            {error}
          </Text>
        )}
      </FormControl>
      
      <Stack direction="row" spacing={4} justifyContent="flex-end">
        <Button
          colorScheme="blue"
          size="lg"
          onClick={handleNext}
        >
          Next
        </Button>
      </Stack>
    </Box>
  );
};

export default TargetHoursStep;